export const DIALOG_TONES = {
  success: {
    accent: '#5C8F73',
    hover: '#4E7E64',
    surface: '#F6FAF8',
    iconBg: '#E8F2EC',
    border: '#D7E6DD',
  },
  warning: {
    accent: '#C4A36A',
    hover: '#B39258',
    surface: '#FBF8F3',
    iconBg: '#F4EBDC',
    border: '#E8DCC8',
  },
  awaiting: {
    accent: '#A8A44A',
    hover: '#96903F',
    surface: '#F8F8F2',
    iconBg: '#EEEDD8',
    border: '#E0DFC4',
  },
  error: {
    accent: '#C46B6B',
    hover: '#B35C5C',
    surface: '#FBF7F7',
    iconBg: '#F5E8E8',
    border: '#E8D4D4',
  },
};

export const tonedDialogPaperSx = toneColors => ({
  '& .MuiDialog-paper': {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 18px 50px rgba(28, 28, 28, 0.10)',
    border: `1px solid ${toneColors.border}`,
    backgroundColor: '#fff',
  },
});

export const tonedActionButtonSx = toneColors => ({
  backgroundColor: `${toneColors.accent} !important`,
  color: '#fff !important',
  boxShadow: 'none',
  fontWeight: 600,
  letterSpacing: '0.02em',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: `${toneColors.hover} !important`,
    boxShadow: 'none',
  },
});
